export class BasicList {
  /** Name of the list */
  private vname: string;
  /** Last element touched */
  last: any;
  /** text filter */
  picker: string;

  dragStart: boolean;
  dragOver: boolean;

  pick: any[];
  list: any[];
  sift: any[];

  constructor(name: string) {
    this.vname = name;
    this.last = null;
    this.picker = "";
    this.dragStart = false;
    this.dragOver = false;

    // Arrays will contain objects of { _id, vname }.
    this.pick = [];
    this.list = [];
    this.sift = [];
  }

  get name(): string {
    return this.vname;
  }
}
